import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters';
import createPersistedstate from 'vuex-persistedstate'

// modules
import user from './modules/user'
import comp from './modules/comp'
import enumStore from './modules/enumStore';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

  },
  getters,

  modules: {
    user,
    comp,
    enumStore
  }
})
